<template>
  <div class="wrapper wrapper-content animated fadeInRight" :key="changeDex">
    <div v-if="centreLangData.length" class="ibox float-e-margins">
      <div class="panel-body ibox-content">
        <!-- Section Title -->
        <div class="row">
          <div class="col-sm-4 form-group">
            <label>{{ $t("message.title") }} ({{ $t("message.English") }}) </label>
            <input type="text" class="form-control" v-model.trim="centreLangData[0].titleEn" data-vv-validate-on="blur" :name="'Title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 60 : 30" autocomplete="off" />
            <label class="error">
              {{ errors.first("Title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
          <div class="col-sm-4 form-group">
            <label>{{$t("message.title")}} ({{$t("message.Traditional Chinese")}})</label>
            <input type="text" class="form-control" v-model.trim="centreLangData[0].titleTc" data-vv-validate-on="blur" :name="'Title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 60 : 30" autocomplete="off" />
            <label class="error">
              {{ errors.first("Title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
          <div class="col-sm-4 form-group">
            <label>{{$t("message.title")}} ({{$t("message.Simplified Chinese")}})</label>
            <input type="text" class="form-control" v-model.trim="centreLangData[0].titleSc" data-vv-validate-on="blur" :name="'Title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 60 : 30" autocomplete="off" />
            <label class="error">
              {{ errors.first("Title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
        </div>
        <!-- row --->
        <!-- Sub-title En-->
        <div class="row form-group">
          <label class="col-sm-2 control-label"> {{ $t("message.Sub-title") }} ({{ $t("message.English") }}) </label>
          <div class="col-sm-10">
            <textarea type="text" class="form-control" v-model.trim="centreLangData[0].subTitleEn" data-vv-validate-on="blur" :name="'Sub-title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 500 : 300" autocomplete="off" />
            <label class="error">
              {{ errors.first("Sub-title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
        </div>
        <!-- Sub-title Tc-->
        <div class="row form-group">
          <label class="col-sm-2 control-label"> {{ $t("message.Sub-title") }} ({{$t("message.Traditional Chinese")}})</label>
          <div class="col-sm-10">
            <textarea type="text" class="form-control" v-model.trim="centreLangData[0].subTitleTc" data-vv-validate-on="blur" :name="'Sub-title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 500 : 300" autocomplete="off" />
            <label class="error">
              {{ errors.first("Sub-title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
        </div>
        <!-- Sub-title Sc-->
        <div class="row form-group">
          <label class="col-sm-2 control-label"> {{ $t("message.Sub-title") }} ({{$t("message.Simplified Chinese")}})</label>
          <div class="col-sm-10">
            <textarea type="text" class="form-control" v-model.trim="centreLangData[0].subTitleSc" data-vv-validate-on="blur" :name="'Sub-title - ' + langLabel(centreLangData[0].langCode)" :maxlength="centreLangData[0].langCode == 'en_US' ? 500 : 300" autocomplete="off" />
            <label class="error">
              {{ errors.first("Sub-title - " + langLabel(centreLangData[0].langCode)) }}
            </label>
          </div>
        </div>

        <div :id="'tab-' + index" v-for="(langItem, index) in visibleListingItems" :key="langItem.id || index" class="item-grp">
          <div style="font-size: 1.2em; margin-bottom: 12px;">Listing Item - {{ index + 1}}</div>
          <!--Centres Name -->
          <div class="row form-group">
            <label class="col-sm-2 control-label">ID<span style="color: red">*</span></label>
            <div class="col-sm-10">
              <div>
                <input type="text" class="form-control" v-model.trim="langItem.content" v-validate="'required'" data-vv-validate-on="blur" :name="'Url - ' + langLabel(langItem.langCode)" autocomplete="off" />
                <label class="error">{{ errors.first("Url - " + langLabel(langItem.langCode)) }}</label>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-sm-2 control-label">
              {{ $t("message.Centres Name") }} ({{ $t("message.English") }})
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <input type="text" class="form-control" v-model.trim="langItem.titleEn" v-validate="'required'" data-vv-validate-on="blur" :name="'Centre Name - ' + langLabel(langItem.langCode)" :maxlength="langItem.langCode == 'en_US' ? 500 : 300" autocomplete="off" />
              <label class="error">
                {{ errors.first("Centre Name - " + langLabel(langItem.langCode)) }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-sm-2 control-label">
              {{ $t("message.Centres Name") }} ({{$t("message.Traditional Chinese")}})
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <input type="text" class="form-control" v-model.trim="langItem.titleTc" v-validate="'required'" data-vv-validate-on="blur" :name="'Centre Name - ' + langLabel(langItem.langCode)" :maxlength="langItem.langCode == 'en_US' ? 500 : 300" autocomplete="off" />
              <label class="error">
                {{ errors.first("Centre Name - " + langLabel(langItem.langCode)) }}
              </label>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-sm-2 control-label">
              {{ $t("message.Centres Name") }} ({{$t("message.Simplified Chinese")}})
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <input type="text" class="form-control" v-model.trim="langItem.titleSc" v-validate="'required'" data-vv-validate-on="blur" :name="'Centre Name - ' + langLabel(langItem.langCode)" :maxlength="langItem.langCode == 'en_US' ? 500 : 300" autocomplete="off" />
              <label class="error">
                {{ errors.first("Centre Name - " + langLabel(langItem.langCode)) }}
              </label>
            </div>
          </div>

          <!-- Banner Image -->
          <div class="row form-group">
            <label class="col-sm-2 control-label">
              {{ $t("message.bannerImage") }}
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <div class="image-previewer">
                <img :src="langItem.imageEn" v-if="langItem.imageEn" />
              </div>
              <div
                class="deleteImage"
                v-if="langItem.imageEN"
                @click="
                  langItem.imageEN = '';
                  langItem.fileObject = null;
                "
              >
                <i class="fa fa-close"></i>
              </div>
              <input type="file" @change="changAttach($event, langItem, 'imageEn')" />
              <img v-if="langItem.imageEN" :src="langItem.imageEN" style="max-width: 200px; margin-top: 10px" />
            </div>
          </div>
          <div style="text-align: right;">
            <button class="btn btn-white" @click="removeItem(langItem)">{{$t("message.Delete")}}</button>
          </div>
          
        </div>

        <div style="padding: 20px 0 120px; display: flex; justify-content: flex-end; gap: 12px;">
          <button class="btn btn-primary" @click="addItem()">{{ $t("message.Add New Item") }}</button>
          <button class="btn btn-primary" @click="submit()">{{ $t("message.Save") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import selectall from "../components/common/selectAll";
import selectrow from "../components/common/selectRow";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "EightCentresList",
  mixins: [config.globalMixin],
  components: {
    Multiselect,
    "select-row": selectrow,
    "select-all": selectall,
  },
  data() {
    return {
      changeDex: 0,
      presetData: {
        id: null,
        type: "0",
        centreId: null,
        titleEn: "",
        subTitleEn: "",
        subTitleTc: "",
        subTitleSc: "",
        url: "",
        imageEn: null,
      },
      centreLangData: [
        {
          id: null,
          type: "0",
          // centreId: null,
          titleEn: "Eight Centres",
          titleTc: " 「八大中心」 ",
          titleSc: " 「八大中心」 ",
          subTitleEn: "Discover the career opportunities offered by the eight key areas for the development of Hong Kong as outlined in the National 14th Five-Year Plan ",
          subTitleTc: "探索國家《十四五規劃綱要》中香港八個重點發展領域的事業機遇",
          subTitleSc: "探索國家《十四五規劃綱要》中香港八個重點發展領域的事業機遇",
          content: "eightCentres",//url
          imageEn: null,
        },
        {
          id: null,
          type: "1",
          // centreId: null,
          titleEn: "International Innovation and Technology Centre",
          titleTc: "國際創新科技中心",
          titleSc: "国际创新科技中心",
          subTitleEn: "",
          subTitleTc: "",
          subTitleSc: "",
          content: "technology-centre",//url
          imageEn: null,
        },
      ],
    };
  },
  created: function () {
     this.loadData();
  },
  mounted() {
  },
  computed: {
  // Filters out deleted items and skips the main config item (index 0)
  visibleListingItems() {
    return this.centreLangData.slice(1).filter(item => !item.isDeleted);
  }
},
  methods: {
  async submit() {
    const self = this 
    const preObj = this.getAuthObj;
    // obj.centreLangData = self.$data.centreLangData;
    // return ;
    try {
      const result = await this.$store.dispatch("eightCentres/insertOrUpdateCentre", {preObj, objList: self.$data.centreLangData});

      if (result) {
        alert("Save Successful!");
        await this.loadData();
      }
    } catch (err) {
      console.error("Save failed:", err);
    }
  },

  async loadData() {
    const self = this
    let obj = this.getAuthObj;
    try {
      const response = await this.$store.dispatch("eightCentres/searchCentre", obj);

      if (response && response.data.result) {}
      else return;

      self.$data.centreLangData = response.data.result.map((row)=>({
        ...row,
        imageSc: null,
        imageTc: null,
      }));
      console.log(self.$data.centreLangData)

      self.$data.changeDex++
    } catch (err) {
      console.error("Failed to load data:", err);
    }
  },
  changAttach(event, langItem, targetColumn) {
    const self = this;
    this.getInputFileBase64(event.target)
      .then((base64) => {
        if (!base64) {
          console.warn("No file or read failed");
          return;
        }
        langItem.imageEn = base64
        // self.$data.centreLangData.forEach(({id, rowIndex})=>{
        //   if(id == langItem){
        //     self.$data.centreLangData[rowIndex].imageEn = base64
        //   }
        // })
      })
      .catch((err) => {
        console.error("讀檔失敗", err);
      })
    },

    async getInputFileBase64(inputElement) {
      const file = inputElement && inputElement.files && inputElement.files[0];
      if (!file) return null;
      const dataUrl = await this.fileToDataURL(file);
      return dataUrl;
    },
    fileToDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("FileReader error"));
        reader.readAsDataURL(file);
      });
    },
    // removeItem(langItem) {
    //   // const idx = this.centreLangData.indexOf(langItem);
    //   // if (idx > -1) {
    //   //   this.centreLangData.splice(idx, 1);
    //   // }
    //   const item = this.centreLangData.find(item => item === langItem);
    //   if (item){
    //     item.isDeleted = true;
    //   }
    //   console.log(item);
    // },
    removeItem(langItem) {
    // Find the item in the main array and set the flag to true
    const item = this.centreLangData.find(i => i === langItem);
    if (item) {
      // Use Vue.$set for reactivity safety if isDelete wasn't initialized in data
      this.$set(item, 'isDeleted', true);
      console.log("Marked item for soft delete:", item);
    }
  },
  
  langLabel(langCode) {
    // Keep your existing langLabel method logic here
    return langCode; 
  },
    addItem() {
      this.centreLangData.push({
        id: null,
        type: "0",
        content: "",
        // centreId: null,
        titleTc: "",
        titleSc: "",
        titleEn: "",
        subTitleEn: "",
        subTitleTc: "",
        subTitleSc: "",
        imageEn: null,
      });
    },
    langLabel(lang) {
      if (lang === "EN") return "English";
      if (lang === "TC") return "Traditional Chinese";
      if (lang === "SC") return "Simplified Chinese";
    },
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    publisherLength() {
      let userList = this.rows;
      let superLength = 0;
      for (var i = 0; i < userList.length; i++) {
        if (userList[i].roleId === "Publisher") {
          superLength++;
        }
      }
      this.superLength = superLength;
    },

    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/eightCentresListDetail" });
    },
    datataleCli(row) {
      if (!row || !row.id) return;
      this.$router.push({
        path: "/main/eightCentresListDetail",
        query: { id: row.id },
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },

    setColumns: function () {
      this.columns = [
        {
          label: "",
          align: "center",
          component: selectrow,
          headerComponent: selectall,
        },
        { label: this.$i18n.t("message.Centres Name"), field: "name" + this.$i18n.locale },
        { label: this.$i18n.t("message.createdTime"), field: "createdTime" },
      ];
    },
  },
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
.item-grp {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #ccc;
}
.image-previewer{
  position: relative;
  aspect-ratio: 16/9;
  border: 1px solid #ccc;
  max-width: 420px;
  margin-bottom: 12px;
}
.image-previewer img{
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: contain;
}
</style>
